import React from 'react';
import { ObjectValues } from '@common/types/util-types';
import { EPerformanceFormQuestionType } from '@common/definitions';
import PerformanceFormQuestionText from '../question-text/question-text';
import { ChecklistScreenComponent } from '../competency-question/competency-question';
import ContentModulePreview from '../content-module-preview/content-module-preview';
import TalentReview from '../talent-review/talent-review';

type ComponentProps = {
  highlight?: boolean;
  onOpenComponent?: (screenComponent: any) => void;
  index?: number;
  item: any;
};

export const getComponent = (
  type: ObjectValues<typeof EPerformanceFormQuestionType>
) => {
  switch (type) {
    case EPerformanceFormQuestionType.OPEN_QUESTION:
      return PerformanceFormQuestionText;
    case EPerformanceFormQuestionType.COMPETENCIES:
        return ChecklistScreenComponent;
    case EPerformanceFormQuestionType.CONTENT_MODULE:
      return ContentModulePreview;
    case EPerformanceFormQuestionType.TALENT_REVIEW:
      return TalentReview;
    default:
      return null;
  }
};

export const ScreenComponent = ({
  item,
  index,
  highlight,
  onOpenComponent,
  ...props
}: ComponentProps) => {

  const handleClick = onOpenComponent && (() => onOpenComponent(item));

  const PreviewComponent = getComponent(item?.type);

  if (!item) return null;

  const classNames = ['ScreenComponent'];
  if (highlight) classNames.push('ScreenComponent--highlight');

  return (
    <div className={classNames.join(' ')} onClick={handleClick}>
      {/* @ts-expect-error */}
      <PreviewComponent {...props} item={item} />
    </div>
  );
};

export default ScreenComponent;
